<template>
  <div>
    <div class="tab_container">
      <div v-for="(tab, index) in tabs" 
          :key="index" 
          class="tab_entry" 
          v-bind:class="{ active: isActive(index) }"
          @click="setActive(index)">
        {{ tab.name }}
      </div>
      <div class="tab_dummy"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: [],
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeIndex: this.active,
    };
  },
  methods: {
    isActive(key) {
      if (key === this.activeIndex) return true;
      return false;
    },
    setActive(key) {
      this.activeIndex = key;
    },
  },
};
</script>

<style scoped>
  .tab_container{
    width: 100%;
    display: flex;
  }

  .tab_entry {
    font-size: 15px;
    padding: 5px;
    border-bottom: 1px solid #000;
  }

  .tab_entry.active {
    border-bottom: 0px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
  }

  .tab_dummy { 
    flex: 1 1 auto;
    border-bottom: 1px solid #000;
  }
</style>